export enum RoomEntryState {
    Idle = 0,
    EnteringRoom = 1,
    EnteringRoomDoorOpen = 2,
    InRoom = 3,
    ExitingRoom = 4,
    Unauthorized = 5,
    BoxLeftOpen = 6,
}
